import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button } from 'react-bootstrap';
import axios from 'axios';
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode.js';
import { BsDownload } from 'react-icons/bs';
import { toast } from 'react-toastify';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Estilos padrão do react-datepicker
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR'; // Importa a localização em português
import { format } from 'date-fns';


registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');



const PendingEnterTransactions = () => {
    const [pendingTransactions, setPendingTransactions] = useState([]);
    const [isLoading, setLoading] = useState(false)
    const [startDate, setStartDate] = useState(null); // Estado para armazenar a data selecionada


    const fetchEntradas = async () => {
        setLoading(true);
        try {
            const formattedDate = format(startDate, 'dd/MM/yyyy'); // Formata a data para 'dd/MM/yyyy'
            const response = await apinode.get(`/estoque/flex/${localStorage.idconta}`, {
                params: {
                    data: formattedDate
                }
            });
            toast.success(response.data);
            fetchPendingTransactions();
        } catch (error) {
            toast.error('Erro ao buscar entradas:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPendingTransactions = async () => {
        setLoading(true)
        try {
            // Substitua esta lógica pela chamada real à sua API ou método de obtenção das transações pendentes
            const response = await apinode(`/erpflex/transacoes/entrada/${localStorage.idconta}`);

            setPendingTransactions(response.data);
            setLoading(false)
        } catch (error) {
            setLoading(false)
            toast.error('Erro ao buscar transações pendentes:', error);
        }
    };

    
    
    useEffect(() => {
        // Simulação de uma chamada assíncrona para obter as transações pendentes do estoque
       
        fetchPendingTransactions();
    }, []);

    const handleDateChange = (date) => {
        setStartDate(date);
    };

    return (
        <>
            <Navbar />
            <div className='mt-page'>

                <div className="row">
                    <div className="col-4">
                        <div className="d-flex">

                            <DatePicker
                                selected={startDate}
                                onChange={handleDateChange}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Selecione a data"
                                className="form-control"
                                style={{ width: startDate ? `${(startDate.toLocaleDateString().length + 2) * 8}px` : '100px' }}
                            />

                            <button className="btn btn-primary btn-sm" onClick={fetchEntradas} disabled={isLoading}>
                                {isLoading ? 'Carregando...' : 'Buscar Entradas'}
                            </button>

                            <ReactHtmlTableToExcel
                                id="exportButton"
                                className="btn btn-primary export-button"
                                table="table-to-xls"
                                filename="transacoes_pendentes"
                                sheet="TransacoesPendentes"
                                buttonText={<><i className="fas fa-file-excel"></i> Exportar para Excel</>}
                            />
                        </div>
                    </div>
                </div>




                <div className="table-responsive">
                    {isLoading ? (
                        <div className="table-responsive d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                        </div>

                    ) : (
                        <table id="table-to-xls" className="table table-striped table-bordered" style={{ fontSize: '12px' }}>
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Data Inclusão</th>
                                    <th scope="col">Sku</th>
                                    <th scope="col">Produto</th>
                                    <th scope="col">Preco Venda</th>
                                    <th scope="col">Custo</th>
                                    <th scope="col">Qtd Atual </th>
                                    <th scope="col">Qtd Anterior</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Dt Alteração ERPFLEX</th>
                                    <th scope="col">Hr Alteração ERPFLEX</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pendingTransactions.map(transaction => (
                                    <tr key={transaction.codigo}>
                                        <td>{transaction.codigo}</td>
                                        <td>
                                            {transaction.data ?
                                                new Date(transaction.data).toLocaleString() :
                                                null}
                                        </td>

                                        <td>{transaction.sku}</td>
                                        <td>{transaction.descricao}</td>
                                        <td>{transaction.precovenda.toFixed(2)}</td>
                                        <td>{transaction.custo.toFixed(2)}</td>
                                        <td>{transaction.qtd_atual.toFixed(2)}</td>
                                        <td>{transaction.ult_qtd.toFixed(2)}</td>
                                        <td>
                                            {transaction.sync === 'S' ? (
                                                <span className="badge bg-success">Concluída</span>
                                            ) : (
                                                <span className="badge bg-danger">Não concluída</span>
                                            )}
                                        </td>
                                        <td>{transaction.dt_alteracao}</td>
                                        <td>
                                            {transaction.horaajuste}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

            </div >


        </>
    );
};

export default PendingEnterTransactions;
